module.exports = __webpack_public_path__ + "img/wash-protect.3dfc338e.png";